import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'
const vue = new Vue()

const state = {
  /**
     * 配送仓点管理
     */
  distriButionList: [],
  distributionMark: 0,
  distriButionSelect: []

}
const actions = {
  /*
  * 配送平台列表
  * */
  // 获取列表
  [types.DISTRIBUTIONLIST] (context, params) { // 列表
    http.fetch('/api/ycDispatchPlatformPoint/listBypage', params).then(data => {
      // console.log(data)
      context.commit(types.DISTRIBUTIONLIST, data)
    })
  },
  [types.DISTRIBUTIONADD] (context, params) { // 新增
    http.fetch('/api/ycDispatchPlatformPoint/add', params).then(data => {
      context.commit(types.DISTRIBUTIONADD, data)
    })
  },
  [types.DISTRIBUTIONDEL] (context, params) { // 删除
    http.fetch('/api/ycDispatchPlatformPoint/delete', params).then(data => {
      context.commit(types.DISTRIBUTIONDEL, data)
    })
  },
  [types.DISTRIBUTIONUPDATE] (context, params) { // 编辑
    http.fetch('/api/ycDispatchPlatformPoint/update', params).then(data => {
      context.commit(types.DISTRIBUTIONUPDATE, data)
    })
  },
  [types.DISTRIBUTIONALL] (context, params) { // 下拉框
    http.fetch('/api/dispatchPlatform/all', params).then(data => {
      // console.log(data, '下拉框')
      context.commit(types.DISTRIBUTIONALL, data)
    })
  },
  [types.DISTRIBUTIONISUSE] (context, params) { // 禁用
    http.fetch('/api/ycDispatchPlatformPoint/isUse', params).then(data => {
      context.commit(types.DISTRIBUTIONISUSE, data)
    })
  }
}
const mutations = {
  // 仓点列表
  [types.DISTRIBUTIONLIST] (state, data) {
    state.distriButionList = data.obj
  },
  // 新增
  [types.DISTRIBUTIONADD] (state, data) {
    if (data.code === 200) {
      state.distributionMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 编辑
  [types.DISTRIBUTIONUPDATE] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.distributionMark = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 删除
  [types.DISTRIBUTIONDEL] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.distributionMark = 1
      vue.$message({
        showClose: true,
        message: '删除成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 下拉框
  [types.DISTRIBUTIONALL] (state, data) {
    state.distriButionSelect = data.obj
    console.log(state.distriButionSelect)
  },
  // 禁用
  [types.DISTRIBUTIONISUSE] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.distributionMark = 1
      vue.$message({
        showClose: true,
        message: '修改状态成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/distriBution/index.js